import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const documentsModule = {
  namespaced: true,
  state() {
    return {
      documents: [],
    };
  },
  actions,
  getters,
  mutations,
};

export default documentsModule;
